import React from 'react';

export default function ArchiveAddIcon() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 8.75C11.9 8.75 11.81 8.73 11.71 8.69C11.43 8.58 11.25 8.3 11.25 8V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V6.19L13.47 5.47C13.76 5.18 14.24 5.18 14.53 5.47C14.82 5.76 14.82 6.24 14.53 6.53L12.53 8.53C12.39 8.67 12.19 8.75 12 8.75Z"
                fill="currentColor"
            />
            <path
                d="M11.9995 8.74994C11.8095 8.74994 11.6195 8.67994 11.4695 8.52994L9.46945 6.52994C9.17945 6.23994 9.17945 5.75994 9.46945 5.46994C9.75945 5.17994 10.2395 5.17994 10.5295 5.46994L12.5295 7.46994C12.8195 7.75994 12.8195 8.23994 12.5295 8.52994C12.3795 8.67994 12.1895 8.74994 11.9995 8.74994Z"
                fill="currentColor"
            />
            <path
                d="M16 22.75H8C2.25 22.75 2.25 19.7 2.25 17V16C2.25 13.77 2.25 11.25 7 11.25C8.19 11.25 8.63 11.54 9.25 12C9.28 12.03 9.32 12.05 9.35 12.09L10.37 13.17C11.23 14.08 12.79 14.08 13.65 13.17L14.67 12.09C14.7 12.06 14.73 12.03 14.77 12C15.39 11.53 15.83 11.25 17.02 11.25C21.77 11.25 21.77 13.77 21.77 16V17C21.75 20.82 19.82 22.75 16 22.75ZM7 12.75C3.75 12.75 3.75 13.77 3.75 16V17C3.75 19.74 3.75 21.25 8 21.25H16C18.98 21.25 20.25 19.98 20.25 17V16C20.25 13.77 20.25 12.75 17 12.75C16.28 12.75 16.13 12.84 15.7 13.16L14.73 14.19C14.01 14.95 13.04 15.37 12 15.37C10.96 15.37 9.99 14.95 9.27 14.19L8.3 13.16C7.87 12.84 7.72 12.75 7 12.75Z"
                fill="currentColor"
            />
            <path
                d="M5 12.75C4.59 12.75 4.25 12.41 4.25 12V7.99996C4.25 6.05996 4.25 3.64996 7.93 3.29996C8.34 3.25996 8.71 3.55996 8.75 3.97996C8.79 4.38996 8.49 4.75996 8.07 4.79996C5.75 5.00996 5.75 5.94996 5.75 7.99996V12C5.75 12.41 5.41 12.75 5 12.75Z"
                fill="currentColor"
            />
            <path
                d="M18.9994 12.7502C18.5894 12.7502 18.2494 12.4102 18.2494 12.0002V8.00022C18.2494 5.95022 18.2494 5.01022 15.9294 4.79022C15.5194 4.75022 15.2194 4.38022 15.2594 3.97022C15.2994 3.56022 15.6594 3.25022 16.0794 3.30022C19.7594 3.65022 19.7594 6.06022 19.7594 8.00022V12.0002C19.7494 12.4102 19.4094 12.7502 18.9994 12.7502Z"
                fill="currentColor"
            />
        </svg>
    );
}
